import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlareFileTextEditorGutterComponent } from './flare-file-text-editor-gutter.component';

@NgModule({
  declarations: [
    FlareFileTextEditorGutterComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatTooltipModule
  ],
  exports: [
    FlareFileTextEditorGutterComponent
  ]
})
export class FlareFileTextEditorGutterModule { }
